import { Injectable } from '@angular/core'
import { addDoc, collection, doc, DocumentReference, Firestore, getDoc, getDocs, orderBy, query, serverTimestamp, updateDoc } from '@angular/fire/firestore'
import { FirestoreStructure, PayoutStatusEnum, PayoutBatchStatusEnum } from '@parkupp/core'
import * as firestore from 'firebase/firestore'
import { PayoutBatch } from '../../../../parkupp-model/src/models/invoicing/payout-batch.model'
import { VariableService } from './variable.service'

@Injectable({
    providedIn: 'root',
})
export class PayoutBatchService {
    collection = collection(this.firestore, FirestoreStructure.PAYOUT_BATCHES)

    constructor(public firestore: Firestore, private variableService: VariableService) {}

    getDocRef(payoutBatchKey: string): DocumentReference<PayoutBatch> {
        return doc(this.collection, payoutBatchKey) as any
    }

    async getPayoutBatch(payoutBatchKey: string): Promise<PayoutBatch> {
        const docRef = doc(this.collection, payoutBatchKey)
        const docSnap = await getDoc(docRef)
        const payoutBatch = new PayoutBatch(docSnap.data())
        payoutBatch.$key = docSnap.id
        return payoutBatch
    }

    async createOrUpdate(payoutBatch: PayoutBatch) {
        payoutBatch.updatedAt = serverTimestamp() as firestore.Timestamp
        payoutBatch.payoutBatchNumber = await this.variableService.getNewPayoutBatchNumber()
        if (!payoutBatch.$key) {
            payoutBatch.createdAt = serverTimestamp() as firestore.Timestamp
            const docRef = await addDoc(this.collection, payoutBatch.parse())
            return docRef
        } else {
            await updateDoc(doc(this.collection, payoutBatch.$key), payoutBatch.parse())
            return doc(this.collection, payoutBatch.$key)
        }
    }
    async getPayoutBatches(): Promise<PayoutBatch[]> {
        const q = query(this.collection, orderBy('createdAt', 'desc'))
        const querySnapshot = await getDocs(q)
        const payoutBatches = await Promise.all(
            querySnapshot.docs.map(async (doc) => {
                const data = new PayoutBatch(doc.data())
                data.$key = doc.id
                return data
            })
        )
        return payoutBatches
    }
    async deletePayoutBatch(payoutBatchKey: string) {
        const payoutBatchRef = this.getDocRef(payoutBatchKey)

        const payoutBatch = await getDoc(payoutBatchRef)
        if (payoutBatch.exists()) {
            const payoutBatchData = payoutBatch.data()

            // Get all payments with that payoutBatchRef
            const updateFields = {
                payoutBatchRef: null,
                status: PayoutStatusEnum.DUE,
            }
            payoutBatchData.payoutRefs.forEach(async (payoutRef) => {
                await updateDoc(payoutRef as any, updateFields)
            })

            // Set the status to deleted
            payoutBatchData.status = PayoutBatchStatusEnum.DELETED
            await updateDoc(payoutBatchRef, payoutBatchData)
        }
    }
}
